/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

import { TrainClass }  from './train.class';

/**
 *
 * @class StopConsist
 *
 * @brief some train stops can modify basic parameters of a train, like say tonnage if they unload or load.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2019
 *
 */
export class StopConsist {

  /** @var _id the unique id for this penalty */
  public       _id: number               = -1;

  /** @var _tc the train category */
  public       _tc: TrainClass|null      = null;

  /** @var _tonnage (short tons) weight */
  public  _tonnage: number               = 0.0;

  /** @var _length (feet) */
  public   _length: number               = 0.0;

  /** @var _priority scheduling priority */
  public _priority: number               = 0.0;

  /** @var _overtake maximum overtake delay */
  public _overtake: number               = 0.0;

  /** @var _nth the zero based index for this item */
  public      _nth: number              = -1;

  /** @brief standard constructor */
  constructor( id: number,
               tc: TrainClass|null,
                t: number,
                l: number,
                p: number,
                o: number,
              nth: number) {

    this._id               = id;
    this._tc               = tc;
    this._tonnage          = t;
    this._length           = l;
    this._priority         = p;
    this._overtake         = o;
    this._nth              = nth;
  }

}
